import {useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import styled from 'styled-components';
import { PRIMARY } from '../../const/colors';
import { selectActivePage } from '../../features/user/userSlice';
import {useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import ES from '../../assets/images/ES.svg';
import US from '../../assets/images/US.svg';
import PT from '../../assets/images/PT.svg';
import { guardarIdioma } from '../../utils/localStorage';

const ArrowIcon = styled(ArrowDropDownIcon)`
  color: ${PRIMARY};
`;
const Img = styled.img`
  width: ${({size}) => size}px;
  margin-right: ${({margin}) => margin}px;
`;

const StyledItem = styled(MenuItem)`
  h3 {
    text-transform: capitalize;
    font-size: 0.9rem;
  }
`


export default function Dropdown() {
  const [selectedCountry, setSelectedCountry] = useState("ES");
  const [anchorEl, setAnchorEl] = useState(null);
  const activePage = useSelector(selectActivePage);
  const [t, i18n] = useTranslation('global');
  const navigate = useNavigate();
  const countries= [{code: "ES", lang: "es"}, {code: "US", lang: "en"}, {code: "PT", lang: "pt"}];

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const images = {
    ES,
    US,
    PT
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(()=>{
    if(i18n.language !== "en") {
      setSelectedCountry(i18n.language.toUpperCase());
    } else {
      setSelectedCountry("US");
    }
  }, [i18n.language])

  const handleSelectedCountry = (country) => {
    setSelectedCountry(country.code);
    i18n.changeLanguage(country.lang);
    navigate(t(activePage));
    document.documentElement.lang = country.lang;
    setAnchorEl(null);
    guardarIdioma(country.lang);
    //window.location.href = ` http://localhost:3000${t(activePage)}`;
    //console.log(`http://localhost:3000${t(activePage)}`);
  }
  
  return (
    <div>
      <Button
        id="button-lang"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        endIcon={<ArrowIcon />}
        onClick={handleClick}
        sx={{
          ':hover': {
            bgcolor: '#222'
          },
        }}
      >
        <Img
          alt=""
          src={images[selectedCountry]}
          size={26}
          margin={0}
          />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{zIndex: 3000}}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        PaperProps={{sx: {width: 'fit-content'}}}
      >
        {countries.map(country => 
          <StyledItem onClick={()=>handleSelectedCountry(country)} key={`${country.code}-${country.lang}`}> 
          <Img
          alt="United States"
          src={images[country.code]} size={21} margin={5} /> <h3>{(country.lang).toUpperCase()}</h3></StyledItem>
        )}
      </Menu>
    </div>
  );
}
